import { render, staticRenderFns } from "./StorefrontsList.vue?vue&type=template&id=3affaf6a"
import script from "./StorefrontsList.vue?vue&type=script&lang=js"
export * from "./StorefrontsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports